import { INotes } from "../interface/notes";
export class Notes implements INotes {
  constructor(public NotesId: number, public NotesDetail: string, public NotesToSend: string, public CreatedDate: Date) {}
}
export class AdminPost {
  constructor(
    public PostId: number,
    public HeaderText: string,
    public Text: string,
    public UserId: number,
    public CreatedDate: string,
    public ImagePath: string,
    public Days: number
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/notes.ts